/** PLATFORM (MSC) → Jarvis Knowledge: Knowledge Packs Jarvis answers from first. */
import React, { useCallback, useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, PageHeader } from '../../components/finance/financeUi';
import { PackList } from '../../components/jarvis/PackList';
import { PackEditor } from '../../components/jarvis/PackEditor';
import { SourceList } from '../../components/jarvis/SourceList';
import { AddKnowledge } from '../../components/jarvis/AddKnowledge';
import { TestBox } from '../../components/jarvis/TestBox';

export default function JarvisKnowledgePage() {
  const [packs, setPacks] = useState([]);
  const [sel, setSel] = useState(null);
  const [sources, setSources] = useState([]);
  const loadPacks = useCallback(() => api.request('/jarvis/packs').then((p) => { setPacks(p); setSel((s) => (s && p.some((x) => x.pack_id === s) ? s : p[0]?.pack_id || null)); }).catch(() => setPacks([])), []);
  const loadSources = useCallback(() => { if (sel) api.request(`/jarvis/packs/${sel}/sources`).then(setSources).catch(() => setSources([])); }, [sel]);
  useEffect(() => { loadPacks(); }, [loadPacks]);
  useEffect(() => { setSources([]); loadSources(); }, [loadSources]);
  useEffect(() => {
    if (!sources.some((s) => s.status === 'PROCESSING' || s.latest_version?.processing_status === 'PROCESSING')) return undefined;
    const t = setTimeout(loadSources, 4000);
    return () => clearTimeout(t);
  }, [sources, loadSources]);
  const pack = packs.find((p) => p.pack_id === sel);
  const refresh = () => { loadSources(); loadPacks(); };
  return (
    <div className="space-y-6 pb-24" data-testid="jarvis-knowledge-page">
      <PageHeader eyebrow="Platform (MSC) · Jarvis" title="Jarvis Knowledge" subtitle="The MSC knowledge Jarvis answers from first: hardware, setup guides, procedures, pricing programs and pitch scripts. Jarvis names its source, and says so when it can't find one." />
      <Card title="Test Jarvis" testid="jarvis-test-card"><TestBox /></Card>
      <div className="grid gap-6 lg:grid-cols-[280px_1fr]">
        <PackList packs={packs} selected={sel} onSelect={setSel} onCreated={(p) => { loadPacks(); setSel(p.pack_id); }} />
        {pack ? (
          <div className="space-y-6">
            <Card title={pack.name} testid="jarvis-pack-card"><PackEditor pack={pack} onChange={(p) => { if (!p) setSel(null); loadPacks(); }} /></Card>
            <Card title="Documents" testid="jarvis-sources-card"><SourceList rows={sources} onChange={refresh} /><div className="border-t"><AddKnowledge packId={pack.pack_id} onAdded={refresh} /></div></Card>
          </div>
        ) : <p className="text-sm text-muted-foreground">Pick a pack.</p>}
      </div>
    </div>
  );
}
